import {getTheme, ITheme, Panel, PanelType} from '@fluentui/react';
import React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import SplitPane, {Pane} from 'react-split-pane';
import history from '../../history';
import {messageService} from '../../services/messageService';
import ConfirmationDialog from '../../shared/confirmationDialog/confirmationDialog';
import {getContractingUnit} from '../../shared/util';
import {pmolFormData, ProjectMolecule} from '../../types/projectMolecule';
import {BookMarkItem} from '../../types/template';
import '../style/style.css';
import CommandBarLeft from './commandBar/commandBarLeft';
import CommandBarRight from './commandBar/commandBarRight';
import DocumentPane from './documentPane/container';
import DocumentPaneSection from '../../shared/mainUI/documentPaneSection/documentPaneSection';
import withMainUI from '../../shared/mainUI/withMainUI';
import ListPane from './listPane/container';
import ListPaneSection from '../../shared/mainUI/listPaneSection/component';
import ShortCutPane from './shortCutPane/container';
import {
  clearFormData,
  filterOrganisationSettingListPaneData,
  getTaxonomyList,
  readByOrganisationSettingId,
  readOrganisationSettingShortCutPaneData,
  readOrganizationSettingTaxonomyLevels,
  readOrgPersonTypeDropdown,
  saveOSStateAttr,
} from '../../reducers/organisationSettingReducer';
import {
  OrganisationSettingListItem,
  OrganisationSettingListPaneFilter,
  ORGSettingShortCutPaneItem,
} from '../../types/organisationSetting';
import {resizerStyle} from "../../shared/customStyle/commonStyles";

export interface State {
  filter: OrganisationSettingListPaneFilter;
  formData: ProjectMolecule;
  loading: boolean;
  showPanel: boolean;
  width: number;
  activeClass: string;
  bookmarkDivClass: string;
  showDetails: boolean;
  autoSave: boolean;
  isEdit: boolean;
  isDisableNewButton: boolean;
  isDrag: boolean;
  resetLayout: boolean;
  collapseBookmarkPane: boolean;
  reSizer: number;
  projectId: null | string;
  selectedShortCutItem: ORGSettingShortCutPaneItem;
  selectedOrgSetting: any;
  readOrgPersonTypeDropdown: any;
}

interface Props extends WithTranslation {
  match: any;
  resetFormData: () => void;
  showProgressBar: boolean;
  formData: ProjectMolecule;
  setUid: () => void;
  clearUid: () => void;
  resetIsChange: () => void;
  uid: string | null;
  autoSave: boolean;
  isChange: boolean;
  isEdit: boolean;
  isDataLoaded?: boolean;
  loadMsg: string;
  location: any;
  loading: boolean;
  handleShowDocumentPane: () => void;
  reSizer: number;
  showDetails: boolean;
  showPanel: boolean;
  handleScroll: () => void;
  currentActiveSection: string;
  animation: any;
  filterOrganisationSettingListPaneData: (filter: OrganisationSettingListPaneFilter) => void;
  // readOrganisationSettingDropDownData:() => void;
  readByOrganisationSettingId: (id: string) => void;
  clearFormData: () => void;
  saveOSStateAttr: any;
  osList: OrganisationSettingListItem[];
  isOSListLoaded: boolean;
  osDropDowns: any;
  reloadListPane: boolean;
  collapseBookmarkPane: boolean;
  selectedShortCutItem: string | null | number;
  readOrganizationSettingTaxonomyLevels: any;
  getTaxonomyList: any;
  readOrgPersonTypeDropdown: any;
}

class OrganisationSettingMainLayout extends React.Component<Props, State> {
  _isMounted = false;
  theme: ITheme = getTheme();
  subscription: any;

  bookmarkList: BookMarkItem[] = [
    {
      id: 1,
      link: 'organisation-taxonomy',
      label: this.props.t('organisationTaxonomy'),
    },
    {
      id: 2,
      link: 'history',
      label: this.props.t('history'),
    },
  ];

  constructor(props: Props) {
    super(props);
    this.state = {
      filter: new OrganisationSettingListPaneFilter(),
      selectedShortCutItem: {
        key: null,
        id: null,
        name: null,
        type: null,
        value: null,
        levelId: null,
      },
      isEdit: false,
      autoSave: false,
      loading: false,
      width: window.innerWidth,
      showPanel: false,
      activeClass: 'grid-righter column-filter-activated',
      bookmarkDivClass: 'bookmark-panel parent',
      showDetails: false,
      formData: pmolFormData,
      isDisableNewButton: false,
      isDrag: false,
      resetLayout: false,
      collapseBookmarkPane: false,
      reSizer: screen.width,
      projectId: null,
      selectedOrgSetting: null,
      readOrgPersonTypeDropdown: null,
    };
  }

  componentDidMount() {
    this.handleUrlChange();
    //this.props.readOrganisationSettingDropDownData()
    this.props.readOrganizationSettingTaxonomyLevels();
    this.props.saveOSStateAttr('selectedShortCutItem', 1);
    this.props.filterOrganisationSettingListPaneData(new OrganisationSettingListPaneFilter());
    this.props.getTaxonomyList(new OrganisationSettingListPaneFilter());
    this.props.readOrgPersonTypeDropdown();
    if (
      location.pathname.split('/').pop() === 'new' &&
      this.state.formData &&
      this.state.formData.id === null
    ) {
      this.createNew();
    }
    this.setState(
      {
        formData: this.props.formData,
      },
      this.props.handleShowDocumentPane,
    );
    this.subscription = messageService.getMessage().subscribe((data: any) => {
      if (data) {
        if (data.data.hideDocumentPane) {
          this.hideDocumentPane();
        }

        if (data.data.isNewOS) {
          this.createNew();
        }

        if (data.data.collapseDocumentPane) {
          this.setState({
            reSizer: this.props.reSizer === 300 ? screen.width / 2 : 300,
            isDrag: !this.state.isDrag,
            collapseBookmarkPane: !this.state.collapseBookmarkPane,
            resetLayout: !this.state.resetLayout,
          });
        }

        if (
          data &&
          data.data &&
          data.data.hasOwnProperty('isLoadingPMOLData') &&
          data.data.isLoadingPMOLData
        ) {
          this.setState({ isDisableNewButton: true });
        } else if (
          data.data.hasOwnProperty('isLoadingPMOLData') &&
          !data.data.isLoadingPMOLData
        ) {
          this.setState({ isDisableNewButton: false });
        }


        if (data.data.selectedOrgSetting) {
          this.setState({ selectedOrgSetting: data.data.selectedOrgSetting });
        }
      }
    });
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state?.selectedItem) {
      if (this.props.location.state.selectedItem) {
        messageService.sendMessage({ selectedShortCutPaneItem: this.props.location.state.selectedItem.id });
        this.setState(
          {
            selectedShortCutItem: this.props.location.state.selectedItem,
            filter: {
              ...this.state.filter,
              organizationTaxonomyLevelId: this.props.location.state.selectedItem.levelId ? this.props.location.state.selectedItem.levelId : null,
            },
          },
          this.reloadListPaneItem,
        );
      }
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.props.reloadListPane !== prevProps.reloadListPane && this.props.reloadListPane) {
      this.reloadListPaneItem();
    }
    if (this.props.match.url !== prevProps.match.url) {
      this.handleUrlChange();
    }
    if (this.props.formData !== prevProps.formData) {
      this.setState({
        formData: this.props.formData,
      });
    }
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state?.selectedItem &&
      prevProps.location.state?.selectedItem != this.props.location.state?.selectedItem
    ) {
      if (this.props.location.state.selectedItem) {
        this.setState(
          {
            selectedShortCutItem: this.props.location.state.selectedItem,
            filter: {
              ...this.state.filter,
              organizationTaxonomyLevelId: this.props.location.state.selectedItem.levelId ? this.props.location.state.selectedItem.levelId : null,
            },
          },
          this.reloadListPaneItem,
        );
      }
    }
    if (this.props.collapseBookmarkPane !== prevProps.collapseBookmarkPane) {
      this.setState({
        collapseBookmarkPane: this.props.collapseBookmarkPane,
      });
    }
  }

  handleUrlChange() {
    let id = this.props.match.params.featureId ? this.props.match.params.featureId : null;

    if (id) {
      this.props.readByOrganisationSettingId(id);
    }

    this.setState(
      {
        isEdit: !!this.props.match.params.featureId,
        isDisableNewButton: id ? true : false,
      },
      this.props.handleShowDocumentPane,
    );
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  // 2. clear states in this method and save to state
  // 3. update redirect url
  createNew = (): void => {
    this.props.clearFormData();
    //this.props.setUid();
    let formData: any = {
      title: null,
      // ....
    };
    this.setState({
      formData: formData,
    });
    history.push(`/organisation-settings/new`);
  };

  reloadListPaneItem = () => {
    setTimeout(() => {
      this.props.filterOrganisationSettingListPaneData(this.state.filter);
      this.props.getTaxonomyList(this.state.filter);
    }, 100);
  };

  renderShortCutPane = () => {
    return (
      <ShortCutPane
        isExpand={this.state.collapseBookmarkPane}
        toggleOverlay={this.state.collapseBookmarkPane}
        resetLayout={this.state.resetLayout}
      />
    );
  };

  getDocumentPaneView = () => {
    return (
      <DocumentPaneSection
        collapseBookmarkPane={true}
        showProgress={this.props.showProgressBar}
        handleScroll={this.props.handleScroll}
        isEdit={this.props.isEdit}
        formData={this.state.formData}
        bookmarkList={[]}
        currentActiveSection={this.props.currentActiveSection}
        renderCommandBar={() => <CommandBarRight/>}
      >
        <DocumentPane
          formData={this.props.formData}
          isExpand={false}
          selectedOrgSetting={this.state.selectedOrgSetting}
        />
      </DocumentPaneSection>
    );
  };

  private getListPaneView = () => {
    return (
      <ListPaneSection
        activeClass={this.state.activeClass}
        titlePaneHeader={
          (this.state.selectedShortCutItem && this.state.selectedShortCutItem.name)
            ? this.state.selectedShortCutItem.name!!
            : 'All'
        }
        showProgress={this.props.showProgressBar}
        renderCommandBar={() => <CommandBarLeft disable={false}/>}
        renderShotcutPane={() => this.renderShortCutPane()}
      >
        <ListPane
          projectId={this.state.projectId}
          loadMsg={this.props.loadMsg}
          reloadListPaneItem={() => this.reloadListPaneItem()}
          filter={this.state.filter}
          listPaneItems={this.props.osList}
          isDataLoaded={this.props.isOSListLoaded}
          isChange={this.props.isChange}
          formData={this.state.formData}
          handelFilter={(filter: OrganisationSettingListPaneFilter) =>
            this.handleFilter(filter)
          }
          handleSelectedListPaneItem={(
            selectedListItemIds: [] | string[],
          ) => {
            //this.handleSelectedListPaneItem(selectedListItemIds);
          }}
          reSizer={this.state.reSizer}
        />
      </ListPaneSection>
    );
  };

  handleFilter = (filter: OrganisationSettingListPaneFilter) => {
    if ((filter.organizationTaxonomyLevelId && filter.organizationTaxonomyLevelId.length >= 3) || filter.organizationTaxonomyLevelId === null) {
      this.setState({
        filter: filter,
      }, this.reloadListPaneItem);
    } else {
      this.setState({
        filter: filter,
      });
    }
  };

  handelShortCutPaneFilter = (selectedItem: ORGSettingShortCutPaneItem) => {
    alert(JSON.stringify(selectedItem));
    this.setState({
      selectedShortCutItem: selectedItem,
    });
  };

  render() {
    const { t } = this.props;
    return (
      <div>
        <div className={'ms-Grid'}>
          <SplitPane
            className={'SplitPane'}
            split="vertical"
            minSize={300}
            maxSize={screen.width / 2}
            defaultSize={
              this.props.showDetails ? screen.width / 2 : screen.width
            }
            resizerStyle={resizerStyle}
            style={{ height: 'calc(100vh - 129px)' }}
            size={this.props.reSizer}
            onDragStarted={() => {
              this.setState({
                // isDrag:true,
                // collapseBookmarkPane:true,
                // resetLayout:false,
              });
            }}
            onResizerDoubleClick={() => {
              this.setState({
                reSizer: this.props.reSizer === 300 ? screen.width / 2 : 300,
                isDrag: !this.state.isDrag,
                collapseBookmarkPane: !this.state.collapseBookmarkPane,
                resetLayout: !this.state.resetLayout,
              });
            }}
            onDragFinished={(newSize: number) => {
              this.setState({
                // isDrag:false,
                // resetLayout:false,
                reSizer: newSize,
                collapseBookmarkPane: newSize < screen.width / 2,
              });
            }}
            onChange={(newSize: number) => {
              if (newSize === screen.width / 2) {
                this.setState({
                  resetLayout: true,
                  collapseBookmarkPane: false,
                });
              }
            }}
          >
            <Pane className={'SplitPane'}>{this.getListPaneView()}</Pane>
            <Pane className={'SplitPane'}>
              {this.props.showDetails && (
                <div
                  className={`${this.props.animation(this.props.showDetails)}`}
                  style={{
                    display: this.props.showDetails ? 'block' : 'none',
                    transition: 'all 0.9s linear',
                  }}
                >
                  {!this.props.showPanel && (
                    <div>{this.getDocumentPaneView()}</div>
                  )}
                </div>
              )}
            </Pane>
          </SplitPane>
        </div>
        <Panel
          isOpen={this.props.showPanel}
          type={PanelType.smallFixedFar}
          onDismiss={this._hidePanel}
          isLightDismiss={true}
          headerText={t('corporateProductCatalogue')}
          className="custom-detail-panel"
          closeButtonAriaLabel={t('close')}
        >
          {this.getDocumentPaneView()}
        </Panel>

        <ConfirmationDialog
          hidden={true}
          title={t('areyousure')}
          subText={t('youwonTbeabletorevertthis')}
          onClickConfirmDialog={() => {
          }}
          onClickCancelDialog={() => {
          }}
          cancelButtonText={t('noIwonT')}
          confirmButtonText={t('yesDeleteit')}
        />
      </div>
    );
  }

  private _hidePanel = () => {
    this.setState({ showPanel: false, showDetails: false });
    history.push(`/organisation-settings`);
  };

  private hideDocumentPane = () => {
    if (getContractingUnit()) {
      history.push(`/CU/${getContractingUnit()}/organisation-settings`);
    } else {
      history.push(`/organisation-settings`);
    }
  };
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    shortcutPaneData: state.os?.osShortCutPaneData,
    isOSListLoaded: state.os.isOSListLoaded,
    osList: state.os.osList,
    osDropDowns: state.os.osDropDowns,
    reloadListPane: state.os.reloadListPane,
    formData: state.os.formData,
    selectedShortCutItem: state.os.selectedShortCutItem,
    orgTaxonomyLevels: state.os.orgTaxonomyLevels,
    showProgressBar: state.os.showProgressBar,
    isEdit: state.os.isEdit,
    personRoleDropdowns: state.os.personRoleDropdowns,
  };
};

const mapDispatchToProps = {
  readOrganisationSettingShortCutPaneData,
  filterOrganisationSettingListPaneData,
  // readOrganisationSettingDropDownData,
  readByOrganisationSettingId,
  clearFormData,
  saveOSStateAttr,
  readOrganizationSettingTaxonomyLevels,
  getTaxonomyList,
  readOrgPersonTypeDropdown,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(withMainUI((OrganisationSettingMainLayout))),
  ));
